import React, { useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";

/*
export function useLogoutToken() {
  return useMutation({
    mutationFn: async () => {
      const { data } = await axios.post(
         BASE_URL+'/token/',
        //'http://localhost:8000/token/',
        { refresh_token: localStorage.getItem('refresh_token') },
        {
          headers: {
            'Content-Type': 'application/json'
          },
          withCredentials: true
        }
      );
      // Return the data or handle it as needed
      return data;
    },
  });
}
*/
const Logout: React.FC = () => {
  const navigate = useNavigate();
  const { keycloak } = useKeycloak();
  // const { mutateAsync: logoutToken, isPending: isLogoutToken } = useLogoutToken();

  useEffect(() => {
    const performLogout = async () => {
      await localStorage.clear();
      axios.defaults.headers.common['Authorization'] = null;
      await keycloak.logout();

      //navigate('/');
    };

    // Call the function to perform logout
    performLogout();
  }, []);

  return (
    <div>Logging out ....</div>
  );
};
export default Logout;
